import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomNumber } from '../Number';
/**
 * Price.
 *
 * @param {PriceProps} props price's props
 * @returns {React.FC<PriceProps>} Price.
 */
export var Price = function (options) {
    var t = useTranslation().t;
    return (React.createElement("div", { className: options.className + " custom-price" },
        t('COMMONS.PRICE'),
        ' ',
        React.createElement(CustomNumber, { amount: options.amount, thousandSeparator: options.thousandSeparator || '.', decimalSeparator: options.decimalSeparator || ',' })));
};
//# sourceMappingURL=Price.js.map